import React, { useState } from 'react';
import ContextMenuButton from 'Common/Components/ContextMenuButton';
import Button from 'shared/ui/Button';
import EditColumnContext from 'Common/Components/EditColumnContext';
import { EditColumns } from 'Screens/Contextualization/Manage/components/CustomActionBar/styled';

const AddRemoveColumnsButton = ({ fields, resetDefault, setFieldVisibility, setNewOrderColumns }) => {
  const [showContext, toggleContext] = useState(false);

  const addRemoveColumns = (
    <EditColumnContext
      trigger="action-button-column"
      fields={ fields }
      toggle={ () => toggleContext(!showContext) }
      setFieldVisibility={ setFieldVisibility }
      setNewOrderColumns={ setNewOrderColumns }
      resetDefault={ resetDefault }
    />
  );

  return (
    <ContextMenuButton
      opened={ showContext }
      menu={ addRemoveColumns }
      trigger="action-button-column"
      display
      icon={ <Button variant="ghost" startIcon={ <EditColumns /> } title="More" ariaLabel="More" onClick={ () => {} } /> }
    />
  );
};

export default AddRemoveColumnsButton;
